import React from "react";
import { IChildren } from "@components/interfaces/IChildren";
import "./VestingPopup.scss";

const VestingPopup = ({ children }: IChildren) => {
  return <div className="vesting-popup">{children}</div>;
};

export default VestingPopup;
